import { render, staticRenderFns } from "./TableType1.vue?vue&type=template&id=25d32180&scoped=true&"
import script from "./TableType1.vue?vue&type=script&lang=js&"
export * from "./TableType1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d32180",
  null
  
)

export default component.exports